import React, { useEffect, useState } from 'react';
import { KOVA_RENK, konuAyarCoz, konuAyarYaz, konuAdetToplami } from './yardimcilar';

// ============================================================
// KONU BAZLI SEVİYE (Faz C, 2026-09-03 — kullanıcı kararı: "ders ve konu bazlı
// zorluk seviyeleri seçilebilir"). Dersin konu listesi DB `konu` sütunundan
// (/api/sorular/meta/konular — motorun PARTITION BY konu taksonomisiyle aynı;
// kazanım haritası konusu DEĞİL). Her konuda [—][K][O][Z]: "—" = dersin profili.
// Backend sözleşmesi: ayarlar.denemeZorluk[ders].konular = { konu: kova | {kova, adet} }.
// Fizibilite yanıtı konu_override[] ile havuz durumunu (uygun/borç/yok/yetersiz) verir.
// KONU BAŞINA ADET (2026-09-03 gece, kullanıcı kararı "tam N, sert"): her konuda
// isteğe bağlı adet kutusu — o konudan TAM N soru, ders kotası İÇİNDE; ders içi
// toplam kotayı aşamaz (kutu kırpar). Havuz N'i karşılamıyorsa fizibilite kırmızı.
// ============================================================

// ders|müfredat → [{konu, sayi}] — A/B'de 10 ders × müfredat için tekrar fetch olmasın.
const onbellek = new Map();
export function konuOnbellekTemizle() { onbellek.clear(); }

const SEVIYELER = [
  ['', '—', 'Dersin profili (konu ayarı yok)'],
  ['kolay', 'K', 'Kolay — bu konunun soruları kolay kovadan'],
  ['orta', 'O', 'Orta — bu konunun soruları orta kovadan'],
  ['zor', 'Z', 'Zor — bu konunun soruları zor kovadan'],
];

// slot-ders (2026-09-03): `ders` HAVUZ dersidir (meta/konular DB dersi ister), `slot`
// panel anahtarı (data-attr), `kazanimOnek` slotun önekleri (Tarih-1/Tarih-2 konu
// listeleri ayrışsın — backend `kazanim_onek` param'ı). `kota` dersin soru kotası (adet üst sınırı).
export default function KonuZorlukListesi({ apiUrl, ders, slot, kazanimOnek = [], mufredat, kota = null, deger = {}, onDegis, fizibiliteKonu = [] }) {
  const onekStr = (Array.isArray(kazanimOnek) ? kazanimOnek : []).join(',');
  const anahtar = `${ders}|${mufredat || ''}|${onekStr}`;
  const [konular, setKonular] = useState(() => onbellek.get(anahtar) || null);
  const [hata, setHata] = useState(null);

  useEffect(() => {
    if (onbellek.has(anahtar)) { setKonular(onbellek.get(anahtar)); return undefined; }
    let iptal = false;
    const token = localStorage.getItem('yks_token');
    const p = new URLSearchParams({ durum: 'onaylandi', ders });
    if (mufredat) p.set('mufredat', mufredat);
    if (onekStr) p.set('kazanim_onek', onekStr);
    setKonular(null);
    fetch(`${apiUrl}/api/sorular/meta/konular?${p}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then(r => r.json())
      .then(d => {
        const liste = Array.isArray(d.konular) ? d.konular : [];
        onbellek.set(anahtar, liste);
        if (!iptal) setKonular(liste);
      })
      .catch(e => { if (!iptal) { setHata(e.message); setKonular([]); } });
    return () => { iptal = true; };
  }, [apiUrl, anahtar, ders, mufredat, onekStr]);

  const durumlar = Object.fromEntries((fizibiliteKonu || []).map(k => [k.konu, k]));
  const yaz = (konu, ayar) => {
    const y = konuAyarYaz(ayar);
    const yeni = { ...deger };
    if (y == null) delete yeni[konu]; else yeni[konu] = y;
    onDegis(yeni);
  };
  const sec = (konu, kova) => yaz(konu, { ...konuAyarCoz(deger[konu]), kova });
  const sabitToplam = konuAdetToplami(deger);
  const adetYaz = (konu, ham) => {
    const cur = konuAyarCoz(deger[konu]);
    let n = parseInt(ham, 10);
    if (!Number.isInteger(n) || n < 1) n = null;
    else {
      // Ders içi Σadet kotayı aşamaz: bu konunun üst sınırı = kota − diğer konuların adedi.
      const digerToplam = sabitToplam - (cur.adet || 0);
      const ust = kota != null ? Math.max(1, kota - digerToplam) : 100;
      n = Math.min(n, ust);
    }
    yaz(konu, { ...cur, adet: n });
  };
  const seciliSayi = Object.keys(deger).length;
  const kotaAsimi = kota != null && sabitToplam > kota;

  const durumRozeti = (f) => {
    if (!f || f.durum === 'uygun') return null;
    const stil = {
      borc: ['bg-amber-100 text-amber-800', 'borç', `${f.hedef_kova} havuzu ${f.havuz ? f.havuz[f.hedef_kova] : 0}${f.adet ? `/${f.adet}` : ''} — kalanı komşu kovadan dolacak`],
      kota_yok: ['bg-red-100 text-red-800', 'kota 0', `${f.hedef_kova} kotası 0 — ${f.adet ? 'adet komşu kovalardan sayılacak' : 'ayar uygulanamaz'}`],
      kota_asimi: ['bg-amber-100 text-amber-800', 'kota aşımı', `${f.hedef_kova} kotası ${f.adet} soruyu karşılamıyor — fazlası komşu kovalardan sayılacak`],
      yetersiz: ['bg-red-100 text-red-800 font-bold', `yetersiz ${f.havuz ? f.havuz.toplam : 0}/${f.adet}`, 'Konu havuzu istenen adedi karşılamıyor — basım kapalı (adet sert)'],
      yok: ['bg-red-100 text-red-800', 'yok', 'havuzda yok'],
    }[f.durum] || ['bg-gray-100 text-gray-700', f.durum, f.durum];
    return <span className={`px-1 rounded ${stil[0]}`} title={stil[2]}>{stil[1]}</span>;
  };

  return (
    <div className="mt-1 rounded border border-indigo-200 bg-white p-1.5 text-[10px] max-w-md" data-konu-listesi={slot || ders}>
      <div className="flex items-center justify-between mb-1 gap-1">
        <span className="font-semibold text-indigo-800">
          Konu bazlı seviye{seciliSayi > 0 ? ` · ${seciliSayi} konu` : ''}
          {sabitToplam > 0 && (
            <span className={`ml-1 px-1 rounded ${kotaAsimi ? 'bg-red-100 text-red-800' : 'bg-indigo-50 text-indigo-700'}`}
              title={kotaAsimi ? 'Konu adetleri toplamı ders kotasını aşıyor' : 'Adet verilen konuların toplamı (ders kotası içinde)'}>
              {sabitToplam}{kota != null ? `/${kota}` : ''} sabit
            </span>
          )}
        </span>
        {seciliSayi > 0 && (
          <button type="button" onClick={() => onDegis({})} className="px-1 rounded hover:bg-indigo-50" title="Bu dersin konu ayarlarını sil">temizle</button>
        )}
      </div>
      {konular === null && !hata && <div className="opacity-60">yükleniyor…</div>}
      {hata && <div className="text-red-600">konu listesi alınamadı: {hata}</div>}
      {konular && konular.length === 0 && !hata && <div className="opacity-60">bu ders/müfredatta onaylı konu yok</div>}
      {konular && konular.length > 0 && (
        <div className="max-h-40 overflow-y-auto space-y-0.5">
          {konular.map(k => {
            const { kova: v, adet } = konuAyarCoz(deger[k.konu]);
            const f = durumlar[k.konu];
            return (
              <div key={k.konu} className="flex items-center gap-1">
                <span className="flex-1 truncate" title={k.konu}>{k.konu} <span className="opacity-50">({k.sayi})</span></span>
                {durumRozeti(f)}
                <span className="inline-flex rounded overflow-hidden border border-gray-200">
                  {SEVIYELER.map(([id, l, t]) => (
                    <button key={id || 'yok'} type="button" onClick={() => sec(k.konu, id)} title={t}
                      aria-pressed={v === id}
                      className={`px-1.5 py-0.5 ${v === id
                        ? (id ? `${KOVA_RENK[id]} font-bold` : 'bg-gray-200 font-bold')
                        : 'bg-white hover:bg-gray-50 text-gray-500'}`}>
                      {l}
                    </button>
                  ))}
                </span>
                {/* Boş kutuda gri sayı = sunucunun varsayılan konu planı (2026-09-30; fizibilite konu_override.adet). */}
                <input type="number" min={1} max={kota || 100} value={adet ?? ''}
                  placeholder={adet == null && f && f.adet ? String(f.adet) : '—'}
                  aria-label={`${k.konu} adet`}
                  title={adet == null && f && f.adet
                    ? `Varsayılan plan: bu konudan ${f.adet} soru (ÖSYM dağılımı). Değiştirmek için adet yazın — bir konuya adet yazınca bu dersin varsayılan planı devre dışı kalır.`
                    : 'Bu konudan TAM bu kadar soru (ders kotası içinde; boş = adet sınırı yok). Konu adetleri toplamı ders kotasını aşamaz.'}
                  onChange={e => adetYaz(k.konu, e.target.value)}
                  className={`w-11 px-1 py-0.5 rounded border text-center ${adet != null ? 'border-indigo-400 bg-indigo-50 text-indigo-900 font-bold' : 'border-gray-200 text-gray-500'}`} />
              </div>
            );
          })}
        </div>
      )}
      <div className="mt-1 opacity-60">
        Seviye dersin kotasını değiştirmez: o konudan çekilen sorular seçilen kovadan gelir, havuz
        yetmezse komşudan tamamlanır ve raporlanır. Adet: o konudan tam bu kadar soru (ders kotası
        içinde); havuz yetmezse basım kapalı.
      </div>
    </div>
  );
}
